module.exports = __webpack_public_path__ + "1d40dc29bfa69937eb9f6a0af2a5a050.png";